import { render, staticRenderFns } from "./akshaya-patra.vue?vue&type=template&id=0723e128&scoped=true"
import script from "./akshaya-patra.vue?vue&type=script&lang=js"
export * from "./akshaya-patra.vue?vue&type=script&lang=js"
import style0 from "./akshaya-patra.vue?vue&type=style&index=0&id=0723e128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723e128",
  null
  
)

export default component.exports